export const HAVE_FAST_PASS: string = 'have_fast_pass';
